const SHOW_MORE_ROW = '.documents--more';
const SHOW_ALL_ROW = '.documents__toggle-all';
const SHOW_MORE_LABEL = '.documents__show-label';
const SHOW_ALL_LABEL = '.documents__toggle-label';
const DOCUMENT_LIST = 'documents-list';
const TYPE_TABLE = '.documents__type-section';

export default class DocumentsList {
  init() {
    DocumentsList.initLatestDocumentsList();
    DocumentsList.onListFiltering();
    DocumentsList.checkLatestLanguages();

    jQuery(document).ajaxComplete(() => {
      DocumentsList.initLatestDocumentsList();
    });
  }

  static initLatestDocumentsList() {
    jQuery(SHOW_ALL_ROW).toggleClass('hidden', document.querySelector(SHOW_MORE_ROW) === null);
    document.getElementsByClassName(DOCUMENT_LIST)[0].addEventListener('click', function (e) {
      DocumentsList.handleListClick(e);
    });
  }

  static handleListClick(e) {
    const viewMoreDocuments = e.target.closest(SHOW_MORE_ROW);
    const viewAllDocuments = e.target.closest(SHOW_ALL_ROW);
    const typeSection = e.target.closest(TYPE_TABLE);
    const $viewAllToggler = jQuery(SHOW_ALL_LABEL);
    const $typeSection = jQuery(typeSection);
    const typesToggler = $typeSection.find(SHOW_MORE_LABEL);

    if (viewAllDocuments) {
      if (jQuery(`.${DOCUMENT_LIST}`).find('.show-old').length > 0) {
        jQuery.each(jQuery('.show-old'), (i, section) => {
          const $viewMoreLabels = jQuery(section).find(SHOW_MORE_LABEL);
          DocumentsList.toggleViewMore(jQuery(section), $viewMoreLabels);
        });
      } else {
        jQuery.each(jQuery(TYPE_TABLE), (i, section) => {
          const $viewMoreLabels = jQuery(section).find(SHOW_MORE_LABEL);
          DocumentsList.toggleViewMore(jQuery(section), $viewMoreLabels);
        });
      }
    }

    if (viewMoreDocuments) {
      DocumentsList.toggleViewMore($typeSection, typesToggler);
    }

    if (jQuery(`.${DOCUMENT_LIST}`).find('.show-old').length > 0) {
      // change to view latest
      jQuery(SHOW_ALL_ROW).addClass('opened');
      jQuery($viewAllToggler.get(0)).addClass('d-none');
      jQuery($viewAllToggler.get(1)).removeClass('d-none');
    } else {
      // change to view all
      jQuery(SHOW_ALL_ROW).removeClass('opened');
      jQuery($viewAllToggler.get(1)).addClass('d-none');
      jQuery($viewAllToggler.get(0)).removeClass('d-none');
    }
  }

  static toggleViewMore($typeSection, typesToggler) {
    if ($typeSection.hasClass('show-old')) {
      // change to view more
      $typeSection.removeClass('show-old');
      jQuery(typesToggler.get(0)).removeClass('d-none');
      jQuery(typesToggler.get(1)).addClass('d-none');
    } else {
      // change to view less
      $typeSection.addClass('show-old');
      jQuery(typesToggler.get(1)).removeClass('d-none');
      jQuery(typesToggler.get(0)).addClass('d-none');
    }
  }

  static onListFiltering() {
    const targetNode = document.getElementById('documents');
    const config = {
      childList: true,
    };

    const callback = function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          DocumentsList.initLatestDocumentsList();
          DocumentsList.checkLatestLanguages();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  static getLanguages() {
    const languages = [];
    jQuery.each(jQuery('.documents thead th'), (i, language) => {
      if (i > 1) {
        languages.push(jQuery(language).text());
      }
    });

    return languages;
  }

  static getMissingDocumentsLang(languages) {
    const missingLanguages = [];
    jQuery.each(jQuery('.latest'), function (i, row) {
      jQuery.each(languages, (i, language) => {
        const noDocumentFound = jQuery(row).find(`[data-title=${language}]`).children().length == 0;
        if (noDocumentFound) {
          missingLanguages.push(language);
        }
      });
    });

    return missingLanguages;
  }

  static hideMissingLangColumn(languages, missingLanguages) {
    const missingCount = [];
    const latestDocumentsAmount = jQuery('.latest').length;
    jQuery.each(languages, (i, lang) => {
      missingCount[i] = jQuery.grep(missingLanguages, function (foundLanguage) {
        return foundLanguage == lang;
      }).length;
      if (missingCount[i] == latestDocumentsAmount) {
        jQuery(jQuery(`.documents thead th`).get(i + 2)).addClass('documents__no-latest');
        jQuery(`[data-title=${languages[i]}]`).addClass('documents__no-latest');
      }
    });
  }

  static checkLatestLanguages() {
    if (!jQuery('.documents__toggle-all').hasClass('opened')) {
      const existingLanguages = DocumentsList.getLanguages();
      const emptyLangColumn = DocumentsList.getMissingDocumentsLang(existingLanguages);
      DocumentsList.hideMissingLangColumn(existingLanguages, emptyLangColumn);
    }
  }
}
